// Adapted from react-core-boilerplate
// https://github.com/NickMaev/react-core-boilerplate

//import Result from "./Result";
import Axios, { AxiosRequestConfig } from "axios";
import  transformUrl  from "transform-url";
import queryString from "query-string";
import { dispatchHideSpinner, dispatchShowSpinner } from "../store/actions/spinnerActions";
//import { isNode, showErrors, getNodeProcess } from "@Utils";
//import SessionManager from "./session";

export const configureAxios = (dispatch) => {
    //const api = Axios.create({
    //    baseURL: 'https://xxxxx.xxxxx.com/xxxxxx/'
    //});

    //axios.defaults.baseURL = ConfigService.getApiURL();

    Axios.interceptors.request.use(request => {
        dispatchShowSpinner(dispatch);
        return request;
    }, error => {
        dispatchHideSpinner(dispatch);
    });

    Axios.interceptors.response.use(response => {
        dispatchHideSpinner(dispatch);
        return response;
    }, error => {
        dispatchHideSpinner(dispatch);
    });
}

export function setToken(token) {
    Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export function clearToken() {
    delete Axios.defaults.headers.common['Authorization']
}

export default class ServiceBase {
    getToken() {
        const token = Axios.defaults.headers.common['Authorization'];
        return token;
    }

    async requestBlob(opts) {
        var axiosResult = null;
        var result = null;
        var errors = null;

        opts.url = transformUrl(opts.url);

        var processQuery = (url, data) => {
            if (data) {
                return `${url}?${queryString.stringify(data)}`;
            }
            return url;
        };

        var axiosOpts = {
            headers: {
                responseType: 'blob'
            }
        };

        try {
            switch (opts.method) {
            case "GET":
                axiosResult = await Axios.get(processQuery(opts.url, opts.data), axiosOpts);
                break;
            case "POST":
                axiosResult = await Axios.post(opts.url, opts.data, axiosOpts);
                break;
            }
            result = { result: true, model: axiosResult.data };
        }
        catch (error) {
            result = { result: false, message: error }
        }

        return result;
    }

    /**
     * Make request with JSON data.
     * @param opts
     */
    async requestJson(opts) {

        var axiosResult = null;
        var result = null;
        var errors = null;

        opts.url = transformUrl(opts.url); // Allow requests also for the Node.

        var processQuery = (url, data) => {
            if (data) {
                return `${url}?${queryString.stringify(data)}`;
            }
            return url;
        };


        // doing this automatically when current user context is placed in redux
        var axiosOpts = {
            //headers: {
            //    Authorization: "Bearer tokenhere"
            //}
        };

        try {
            switch (opts.method) {
                case "GET":
                    axiosResult = await Axios.get(processQuery(opts.url, opts.data), axiosOpts);
                    break;
                case "POST":
                    axiosResult = await Axios.post(opts.url, opts.data, axiosOpts);
                    break;
                case "PUT":
                    axiosResult = await Axios.put(opts.url, opts.data, axiosOpts);
                    break;
                case "PATCH":
                    axiosResult = await Axios.patch(opts.url, opts.data, axiosOpts);
                    break;
                case "DELETE":
                    axiosResult = await Axios.delete(processQuery(opts.url, opts.data), axiosOpts);
                    break;
            }
            result = axiosResult.data;
        }
        catch (error) {
            console.log(error);
            result = {result: false, message: error}
        }

        //if (errors !== undefined) {
        //    result = {
        //        result: false, message: JSON.stringify(...result.errors) };
        //}

        return result;
    }

    /**
     * Allows you to send files to the server.
     * @param opts
     */
    async sendFormData(opts) {
        let axiosResult = null;
        let result = null;

        opts.url = transformUrl(opts.url); // Allow requests also for Node.

        // need to put token here
        var axiosOpts = {
            headers: {
                'Content-Type': 'multipart/form-data'                
            }
        };

        try {
            switch (opts.method) {
                case "POST":
                    axiosResult = await Axios.post(opts.url, opts.data, axiosOpts);
                    break;
                case "PUT":
                    axiosResult = await Axios.put(opts.url, opts.data, axiosOpts);
                    break;
                case "PATCH":
                    axiosResult = await Axios.patch(opts.url, opts.data, axiosOpts);
                    break;
            }
            result = axiosResult.data;
        } catch (error) {
            //result = new Result(null, error.message);
            result = { result: false, message: error };
            return result;
        }

        //if (result.hasErrors) {
        //    showErrors(...result.errors);
        //}

        return result;
    }
}